var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailLarge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "#8E8EA9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1.55A1.3 1.3 0 0 1 1.3.25h36.4a1.3 1.3 0 0 1 1.3 1.3v4.405c0 .898-.727 1.625-1.625 1.625H1.625A1.625 1.625 0 0 1 0 5.955V1.55z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.123 9.985C.32 7.847 0 7.16 0 5.595h38.924c.495 2.214-2.59 4.072-3.733 5.077a6443.077 6443.077 0 0 1-12.72 8.858c-2.56 1.771-4.926.738-5.79 0-3.35-2.291-10.755-7.407-13.558-9.545zM37.05 26.25H1.95c-1.077 0-1.95.766-1.95 1.711v3.078c0 .945.873 1.711 1.95 1.711h35.1c1.077 0 1.95-.766 1.95-1.711V27.96c0-.945-.873-1.711-1.95-1.711z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12.527v17.828h39V12.527c-4.278 3.168-13.597 9.933-16.186 11.644-2.59 1.71-5.447.712-6.551 0L0 12.527z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .25)",
    d: "M0 0h39v32.5H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailLarge);
export default __webpack_public_path__ + "static/media/Email__Large.c571ce7dbad6e30d642d6139968ca0e7.svg";
export { ForwardRef as ReactComponent };